import { call, put, takeEvery, select } from 'redux-saga/effects';
import { gcApi } from 'config/axios';
import {
    FETCH_MUTUAL_CONNECTIONS,
    FETCH_MUTUAL_CONNECTIONS_FETCHING,
    FETCH_MUTUAL_CONNECTIONS_SUCCESS,
    FETCH_MUTUAL_CONNECTIONS_FAIL
} from '../actions/ActionTypes';

const FETCH_SIZE = 10;

export function* fetchMutualConnections({ displayName, reset }) {
    try {
        yield put({
            type: FETCH_MUTUAL_CONNECTIONS_FETCHING,
            reset
        });

        const start = yield select((state) => state.mutualConnections.start);

        const url = `/usersearch-service/search/mutualConnection/${displayName}`;

        const response = yield call(gcApi.get, url, {
            params: {
                start,
                limit: FETCH_SIZE
            }
        });

        yield put({
            type: FETCH_MUTUAL_CONNECTIONS_SUCCESS,
            data: response.data,
            start: start + FETCH_SIZE
        });
    } catch (e) {
        yield put({
            type: FETCH_MUTUAL_CONNECTIONS_FAIL
        });
    }
}

export const mutualConnectionsSagas = [takeEvery(FETCH_MUTUAL_CONNECTIONS, fetchMutualConnections)];
